import React, {Component} from 'react'
import CPageNew from '@/components/CPageNew'
import CBaseComponent from '@/components/CBaseComponent'
import { goodsManageListNewData} from './data'
import {setPageNewItem} from "@/utils";
import './index.scss'
import {message} from "antd";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {normaluserlist, addLibrary} from "../../../../../servers/goodsManageApi";
import {museumnamecheck} from "../../../../../servers/commonApi";

@CBaseComponent
class StoreManageListNew extends Component{

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onSearch = this.onSearch.bind(this);

  }


  state = {
    data: goodsManageListNewData,
  }

  onChange(data){
    this.setState({
      data: setPageNewItem(this.state.data, data.data.id, 'value', data.value)
    })
  }

  onSearch(data){
    if (data.data.name === '博物馆名称' && data.value!=='') {
      const params = {
        name:data.value
      }
      museumnamecheck(params).then(res=>{
          if(res.statecode === 0 &&  res.records.length > 0) {
            const params = this.state.data
            params[0].data[0].options = res.records
            params[0].data[0].value = data.value
            this.setState({
              data:params
            })
          }
      })
    }
  }


  onCancel(){
    this.props.history.push({
      pathname: '/library'
    })
  }

  onSubmit(data){
    if (data.status) {
      const params = data.data
      addLibrary(params).then(res=>{
          if (res.statecode === 0) {
            if(this.getUrlParams(window.location.href).type === 'edit'){
              message.success('编辑成功');
            }
            else {
              message.success('添加成功');
            }
            this.props.history.push({
              pathname: '/library',
            })
          } else {
            if(this.getUrlParams(window.location.href).type === 'edit'){
              message.error(res.statemessage);
            }
            else {
              message.error(res.statemessage);
            }
          }
        }).catch(err=>{

        });
    }
  }
  getUrlParams(url) {
    // 通过 ? 分割获取后面的参数字符串
    let urlStr = url.split('?')[1]
    // 创建空对象存储参数
    let obj = {};
    // 再通过 & 将每一个参数单独分割出来
    let paramsArr = urlStr.split('&')
    for(let i = 0,len = paramsArr.length;i < len;i++){
      // 再通过 = 将每一个参数分割为 key:value 的形式
      let arr = paramsArr[i].split('=')
      obj[arr[0]] = arr[1];
    }
    return obj
  }


  componentWillMount(){
    if(this.getUrlParams(window.location.href).type === 'edit'){
      const params = JSON.parse(sessionStorage.getItem('libraryEdit'))
      const d = {
        name:params.museumname
      }
      museumnamecheck(d).then(res=>{
        if(res.statecode === 0 &&  res.records.length > 0) {
          const result = this.state.data
          result[0].data[0].options = res.records
          result[0].data[0].value = params.museumid
          result[0].data[1].value = params.jointype === '本省推荐' ? '1D10':'1D12'
          result[0].data[2].value = params.micontact
          result[0].data[3].value = params.miphone
          this.setState({
            data:result
          })
        }
      })

    } else {
      let result = this.state.data
      result[0].data[0].value = ''
      result[0].data[0].options = []
      result[0].data[1].value = ''
      result[0].data[2].value = ''
      result[0].data[3].value = ''
      this.setState({
        data:result
      })
    }
  }

  render(){
    return (
      <div className='store-manage-list-new'>
        <CPageNew data={this.state.data}
                  onChange={this.onChange}
                  onSearch={this.onSearch}
                  onSubmit={this.onSubmit}
                  onCancel={this.onCancel}
        />
      </div>
    )
  }
}
export default compose(withRouter)(StoreManageListNew);
